import { getSavedExpoToken } from "@stepapp/core";
import { useUpdates } from "expo-updates";
import React, { useCallback } from "react";
import { StyleSheet } from "react-native";

import { Block, Touchable, Typography, spacing } from "@stepapp/ui";
import { nativeApplicationVersion, nativeBuildVersion } from "expo-application";
import { TEST_OR_STAGING } from "../../config/urls";
import { useCopyToClipboard } from "../../hooks";

const AppVersionInfo = () => {
  const type = TEST_OR_STAGING ? (__DEV__ ? "DEV " : "Beta ") : "";
  const { currentlyRunning } = useUpdates();
  const copyToClipboard = useCopyToClipboard();

  const copyExpoToken = useCallback(() => {
    copyToClipboard(getSavedExpoToken());
  }, [copyToClipboard]);

  return (
    <Block row style={styles.container}>
      <Touchable activeOpacity={1} onPress={copyExpoToken}>
        <Typography type="secondary" variant="label">
          {type}
          {nativeApplicationVersion}({nativeBuildVersion})
          {`${currentlyRunning?.updateId ? ` - ${currentlyRunning.updateId.slice(-8)}` : ""}`}
        </Typography>
      </Touchable>
    </Block>
  );
};

export default React.memo(AppVersionInfo);

const styles = StyleSheet.create({
  container: {
    paddingLeft: spacing.unit * 3,
  },
});
